import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import ViewMore from '../../components/ViewMore';

const Problems = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    //
    // beforeChange: function(s, i) {
    //     const slideElement = slider.current.innerSlider.list;
    //
    //     console.log(s,i,slideElement)
    // },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block '}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Complexity & Uncertainty</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              {/*<ViewMore ln={40}>*/}
              When you create and own a SaaS product, it seems so easy for you to understand and imagine its role at the core. But is it that easy to
              explain it to your customer? Often it is tons of technical words that end up with customers’ poker faces. And what about SaaS marketing?
              It is hard to deliver promotional content while simultaneously revealing the product’s functionality and technical aspects.{' '}
              {/*</ViewMore>*/}
            </div>
          </div>
        </div>
        <div className={'w-30p block'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Confusion</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              {/*<ViewMore ln={30}>*/}
              The world of digital solutions may sometimes seem so confusing. We had SaaS products as an innovation, and as soon as we got used to
              them, they were taken to the cloud. There were now two products definitely operating in different ways. For marketing, it is a real
              challenge to explain the features and benefits of a service and not sound boring. {/*</ViewMore>*/}
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Doubt</h3>
          {/*<ViewMore ln={30}>*/}
          Understanding SaaS is one thing; persuading its value is another. Once you explain how your SaaS product works, you should also show the
          benefits, the value, and the way it may change their “lives.” The common practice of fearing every new thing and not trusting, especially
          when you offer them to forget about storing locally and moving to “the unknown,” i.e., the cloud, is quite normal. Still, the longer they
          doubt, the lower your conversions and profit.
          {/*</ViewMore>*/}
        </div>
      </Slider>
    </>
  );
};
export default Problems;
